// extracted by mini-css-extract-plugin
export var colorSquare = "_pa-0";
export var danger = "_pa-5";
export var lightPink = "_pa-8";
export var neutralBlue = "_pa-7";
export var neutralYellow = "_pa-6";
export var normal = "_pa-1";
export var primary = "_pa-2";
export var primaryLight = "_pa-3";
export var solidBlack = "_pa-g";
export var solidGreen = "_pa-b";
export var solidLightBlue = "_pa-d";
export var solidNavy = "_pa-c";
export var solidOrange = "_pa-f";
export var solidPink = "_pa-e";
export var solidRed = "_pa-9";
export var solidYellow = "_pa-a";
export var success = "_pa-4";